import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./WhatsAppIcon.css";

const WHATSAPP_PHONE_NUMBER = "923249925737";

const WhatsAppIcon = () => {
  const phoneNumber = WHATSAPP_PHONE_NUMBER;
  const [active, setActive] = useState(false);
  const { pathname } = useLocation();

  // This is a public-site chat widget — it has no place floating over the
  // admin dashboard or the login screen.
  const isAdminRoute = pathname.startsWith("/dashboard") || pathname === "/login";
  if (isAdminRoute) return null;

  const handleWhatsAppClick = () => {
    if (phoneNumber) {
      setActive(true);
      setTimeout(() => setActive(false), 200); // Reset after animation
      const url = `https://wa.me/${phoneNumber}`;
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      console.error("WhatsApp phone number is not set in environment variables.");
    }
  };

  return (
    <div
      className={`whatsapp-icon ${active ? "active" : ""}`}
      onClick={handleWhatsAppClick}
      role="button"
      aria-label="Chat with us on WhatsApp"
      tabIndex={0}
    >
      <i className="fa-brands fa-whatsapp"></i>
    </div>
  );
};

export default WhatsAppIcon;
